import { render, staticRenderFns } from "./upgrading.vue?vue&type=template&id=5687cce8&scoped=true"
import script from "./upgrading.vue?vue&type=script&lang=js"
export * from "./upgrading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5687cce8",
  null
  
)

export default component.exports